<div
  class="relative mx-auto w-full max-w-[352px]"
  role="dialog"
  aria-modal="true"
  aria-labelledby="system-error-title"
  aria-describedby="system-error-description"
>
  <button
    type="button"
    class="absolute right-2 top-2 flex h-10 w-10 items-center justify-center rounded-full bg-white text-neutral-gray-900 shadow-[0_2px_10px_rgba(0,56,139,0.12),0_0_4px_rgba(169,188,217,0.05)] transition-colors hover:bg-neutral-gray-200"
    aria-label="Cerrar"
    (click)="onClose()"
  >
    <app-svg-icon [iconName]="SvgIcon.CLOSE_MODAL" [size]="20"></app-svg-icon>
  </button>

  <div class="mb-6 flex justify-center">
    <app-svg-icon
      [iconName]="SvgIcon.SYSTEM_ERROR_MODAL"
      [size]="110"
    ></app-svg-icon>
  </div>

  <div class="mb-6 text-center">
    <h2
      id="system-error-title"
      class="mb-4 text-[20px] font-semibold leading-[1.2] text-neutral-gray-900"
    >
      {{ title }}
    </h2>

    <div
      id="system-error-description"
      class="space-y-1 text-[14px] leading-[1.5] text-neutral-gray-700"
    >
      <p *ngFor="let line of bodyLines()">{{ line }}</p>
    </div>
  </div>

  <div class="mb-[46px]">
    <ui-button
      class="font-bold w-full"
      [variant]="'primary'"
      [size]="'x-large'"
      [fullWidth]="true"
      (clicked)="onConfirm()"
    >
      {{ confirmLabel }}
    </ui-button>
  </div>
</div>
